import * as React from "react";
import { observer } from "mobx-react";
import { observable } from "mobx";
import { Alert, Button, Classes, Dialog, FormGroup, InputGroup } from "@blueprintjs/core";
import { MDBBtn, MDBCol, MDBRow } from "mdbreact";
import { toast } from "react-toastify";
import IntlCurrencyInput from "react-intl-currency-input";
import { CaixaPostalStore } from "../../stores/caixa-postal/CaixaPostalStore";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { AppStore } from "../../stores/AppStore";
import socket from "../../socket";
import LoadingModal from "../loading/LoadingModal";

const numeral = require("numeral");

interface Props {
    itens: any
    cnpj: string
}

@observer
export default class CaixaPostalSolicitacao extends React.Component<Props, {}> {

    obs = observable({
        open_buy_chave: false as boolean,
        quantidade: "" as string,
        valor_total: 0 as number,
        credito_restantes: 0 as number,
        count: 0 as number,
        pagamento_pix: false as boolean,
        listAssuntos: [] as any,
        open_visualiza_mensagem: false as boolean,
        open_visualiza_erro: false as boolean,
        mensagens: [] as any,
        mensagens_erro: [] as any
    })

    constructor(props: any) {
        super(props);
    }

    async componentDidMount() {
    }

    async handleSolicitaMensagens() {

        if (this.obs.listAssuntos.length <= 0) {
            toast.warn("Selecione pelo menos um assunto!", {});
            return
        }

        if (CaixaPostalStore.obs.credito_contratado < this.obs.listAssuntos.length) {
            toast.warn("Créditos insuficiente!", {});
            return
        }

        let params = {
            assuntos: this.obs.listAssuntos,
            caixapostal_id: this.props.itens[0].caixapostal_id,
            cnpj: this.props.cnpj,
        }

        await CaixaPostalStore.handleSolicitaMensagens(params)
        await CaixaPostalStore.handleConsultaCredito()

    }

    thisValorCompra() {
        let valor_total = parseInt(this.obs.quantidade) * 0.24
        this.obs.valor_total = valor_total
        return (<>
            <MDBCol md="12">
                <div className="blocoAssin">
                    <span className="priceAssinPerfil"><b>R$</b> {numeral(valor_total).format("0,0.00")}</span>
                    <span className="descAssinPerfil">Total de chaves {numeral(this.obs.quantidade).format("0,0")}</span>
                </div>
            </MDBCol>
        </>)
    }

    async handleBuyChaves() {
        if (this.obs.quantidade == "") {
            toast.error("Insira uma quantidade!", {});
            return
        }
        this.obs.open_buy_chave = false
        let quantidade = parseInt(this.obs.quantidade)
        let status = await CaixaPostalStore.handleBuyQuantidade(quantidade)

        if (status) {

            this.handleSocketPaid()
        }
    }

    handleSocketPaid() {
        this.obs.pagamento_pix = true

        let socket_paid = socket.channel("paid:" + AppStore.obs1.contaId);

        socket_paid.join()
            .receive("ok", resp => {
                console.log("Bem vindo 1", resp)
            })
            .receive("error", resp => {
                console.log("Error", resp)
            })

        socket_paid.on("paid", payload => {

            if (payload.body) {
                toast.success('Pagamento recebido com sucesso!');

                CaixaPostalStore.handleConsultaCredito()

                socket_paid.off("paid:" + AppStore.obs1.contaId)

                this.obs.pagamento_pix = false

            } else {
                toast.error('Nenhum pagamento encontrato!');

                this.obs.pagamento_pix = false

            }

        })

    }

    handleCancelPix() {
        CaixaPostalStore.obs.qrcode = ""
        CaixaPostalStore.obs.pix_id = ""
        this.obs.quantidade = ""
        this.obs.pagamento_pix = false
    }

    handleRowSelect = async (row, checked) => {

        if (checked) {
            this.obs.listAssuntos.push({ isn: row.isn, index: row.index });
        } else {
            let index = this.obs.listAssuntos.indexOf(row.index);
            this.obs.listAssuntos.splice(index, 1);
        }
    };

    handleRowSelectAll = async (check, row) => {
        if (check) {
            row?.map(value => {
                this.obs.listAssuntos.push({ isn: value.isn, index: value.index });
            });
        } else {
            this.obs.listAssuntos = [];
        }
    };

    async handleSetMensagem(row: any) {

        if (row.message.conteudo) {

            let variaveis = row.message.conteudo[0].variaveis

            let corpoModelo = row.message.conteudo[0].corpoModelo

            if (corpoModelo) {

                var marcadores = corpoModelo.match(/\+\+\d+\+\+/g)

                marcadores.forEach(function (marcador, index) {

                    var regex = new RegExp("\\+\\+" + (index + 1) + "\\+\\+", "g");

                    corpoModelo = corpoModelo.replace(regex, variaveis[index] || "");

                });

                this.obs.mensagens = [corpoModelo, row.assunto]

                this.obs.open_visualiza_mensagem = true

            } else {

                this.obs.mensagens = [row.message.conteudo[0].mensagem, row.assunto]

                this.obs.open_visualiza_mensagem = true

            }

        }

        if (!row.visualizada) {

            await CaixaPostalStore.handleSaveLog(row)

        }

    }

    handlesetError(row: any) {

        this.obs.mensagens_erro = [row.error, row.assunto]

        this.obs.open_visualiza_erro = true

    }

    render() {

        const currencyConfig = {
            locale: "pt-BR",
            formats: {
                number: {
                    BRL: {
                        style: "currency",
                        currency: "BRL",
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                    },
                },
            },
        };

        const getRestante = () => {
            this.obs.credito_restantes = CaixaPostalStore.obs.credito_contratado - CaixaPostalStore.obs.credito_usados
            return this.obs.credito_restantes
        }

        let unselectable: string[] = [];

        unselectable = []

        let itens = this.props.itens?.map(values => {

            if (values.message) {
                unselectable.push(values.isn);
            }

            return ({

                index: values.index,
                assunto: values.assuntoModelo.replace("++VARIAVEL++", values.valorParametroAssunto),
                isn: values.isn,
                caixapostal_id: values.caixapostal_id,
                id: values.id,
                message: values.message || {},
                error: values.error || "",
                visualizada: values.visualizada || false,
                dataEnvio: values.dataEnvio || ""
            })
        })

        const selectRowProp = {
            mode: "checkbox",
            clickToSelect: false,
            columnWidth: "40px",
            onSelect: this.handleRowSelect,
            onSelectAll: this.handleRowSelectAll,
            isSelected: true,
            selected: this.obs.listAssuntos,
            bgColor: "rgba(27, 98, 111, 0.1)",
            unselectable: unselectable
        };

        const formatVisualizaMensagem = (cell, row) => {
            return (
                <>
                    {row.visualizada ?

                        <MDBBtn
                            size="sm"
                            disabled={(!row.message.conteudo)}
                            onClick={(e) => this.handleSetMensagem(row)}
                        >
                            <img src="/images/envelope.png" onClick={(e) => this.handleSetMensagem(row)} />
                        </MDBBtn>

                        :

                        <MDBBtn
                            size="sm"
                            disabled={(!row.message.conteudo)}
                            onClick={(e) => this.handleSetMensagem(row)}
                        >
                            <img src="/images/e-mail.png" />
                        </MDBBtn>
                    }
                </>
            )
        }

        const formatVisualizaErros = (cell, row) => {
            let erro = false

            if (row.error != "") {

                erro = true

            }

            return (
                <>
                    {erro ?
                        <MDBBtn
                            color="default"
                            size="sm"
                            onClick={(e) => this.handlesetError(row)}
                        >
                            <img src="/images/view.png" />
                        </MDBBtn>
                        : <></>
                    }
                </>
            )
        }

        const format_data_envio = (cell, row) => {

            if (!row.dataEnvio) {
                return ""
            }

            const year = row.dataEnvio.slice(0, 4);
            const month = row.dataEnvio.slice(4, 6);
            const day = row.dataEnvio.slice(6, 8);

            return (`${day}/${month}/${year}`)
        }

        return (
            <>
                <MDBRow md="12">
                    <MDBCol md="12">
                        <MDBRow md="12">
                            <MDBCol md="4">
                                <div className="area-status-assuntos restantes">
                                    <div style={{ display: "flex", margin: "auto" }}>
                                        <div style={{ textAlign: "center", width: "100%", margin: "auto" }}>
                                            <img src="/images/adquirido.png" className="pointer hvr-buzz warning-buzz" onClick={() => this.obs.open_buy_chave = true}></img>
                                        </div>
                                        <div style={{ textAlign: "center", width: "100%", margin: "auto" }}>
                                            <p className="topo-title-xml">{CaixaPostalStore.obs.credito_contratado.toLocaleString('pt-BR')}</p>
                                            <p className="fundo-title-xml">Total Adquirido</p>
                                        </div>
                                    </div>
                                </div>
                            </MDBCol>
                            <MDBCol md="4">
                                <div className="area-status-assuntos usadas" >
                                    <div style={{ display: "flex", margin: "auto" }}>
                                        <div style={{ textAlign: "center", width: "100%", margin: "auto" }}>
                                            <img src="/images/usadas.png"></img>
                                        </div>
                                        <div style={{ textAlign: "center", width: "100%", margin: "auto" }}>
                                            <p className="topo-title-xml">{CaixaPostalStore.obs.credito_usados.toLocaleString('pt-BR')}</p>
                                            <p className="fundo-title-xml">Créditos Utilizadas</p>
                                        </div>
                                    </div>
                                </div>
                            </MDBCol>
                            <MDBCol md="4">
                                <div className="area-status-assuntos adquiradas">
                                    <div style={{ display: "flex", margin: "auto" }}>
                                        <div style={{ textAlign: "center", width: "100%", margin: "auto" }}>
                                            <img src="/images/restantes.png"></img>
                                        </div>
                                        <div style={{ textAlign: "center", width: "100%", margin: "auto" }}>
                                            <p className="topo-title-xml">{getRestante().toLocaleString('pt-BR')}</p>
                                            <p className="fundo-title-xml">Créditos Restantes</p>
                                        </div>
                                    </div>
                                </div>
                            </MDBCol>
                        </MDBRow>
                    </MDBCol>

                    <MDBCol md="12">

                        <FormGroup
                            label="Selecione os Assuntos:"
                            labelFor="empresas"
                        >
                            <div className="select-assunto select-empresa-notificacoes">
                                <BootstrapTable data={itens} selectRow={selectRowProp}>
                                    <TableHeaderColumn dataField="isn" isKey={true} hidden width="1%">#</TableHeaderColumn>
                                    <TableHeaderColumn dataField="assunto" width="60%">Assunto</TableHeaderColumn>
                                    <TableHeaderColumn dataField="isn" width="10%">ISN</TableHeaderColumn>
                                    <TableHeaderColumn dataFormat={format_data_envio} width="15%">Data da Publicação</TableHeaderColumn>
                                    <TableHeaderColumn dataFormat={formatVisualizaMensagem} width="5%"></TableHeaderColumn>
                                    <TableHeaderColumn dataFormat={formatVisualizaErros} width="5%"></TableHeaderColumn>
                                </BootstrapTable>
                            </div>
                        </FormGroup>

                        <MDBCol md="12">
                            <MDBBtn
                                className="btnDefault btnBuscarNfe"
                                onClick={() => this.handleSolicitaMensagens()}
                                style={{ float: "right" }}
                            >
                                Solicitar
                            </MDBBtn>
                        </MDBCol>
                    </MDBCol>
                </MDBRow>

                <Dialog
                    isOpen={this.obs.open_buy_chave}
                    onClose={() => this.obs.open_buy_chave = false}
                    className="AlertUser"
                >
                    <h2 className="titleSEFAZ">Comprar Chaves</h2>

                    <FormGroup label="Quantidade">
                        <InputGroup
                            type="number"
                            value={(this.obs.quantidade)}
                            onChange={(e) => this.obs.quantidade = e.target.value}
                        />
                    </FormGroup>

                    <FormGroup>
                        <label className="bp3-label">Valor de cada Chave</label>
                        <IntlCurrencyInput
                            className="form-control"
                            value={0.24}
                            currency="BRL"
                            config={currencyConfig}
                            disabled
                        />
                    </FormGroup>

                    {this.thisValorCompra()}

                    <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                        <Button text="Cancelar" onClick={() => this.obs.open_buy_chave = false} />
                        <Button text="Confirmar" intent="primary" onClick={() => this.handleBuyChaves()} />
                    </div>
                </Dialog>

                <Alert
                    confirmButtonText="Cancelar"
                    isOpen={this.obs.pagamento_pix}
                    onConfirm={() => this.handleCancelPix()}
                    className="AlertUser"
                    intent="danger"
                >
                    <h2 className="titleSEFAZ">Pagar com Pix</h2>

                    <div style={{ textAlign: "center" }}>
                        <img src={CaixaPostalStore.obs.qrcode} width="200" />
                        <br />
                        <br />
                        <h6><b>Total: {numeral(this.obs.valor_total).format("0,0.00")}</b></h6>
                        <br />

                        <div style={{ display: "inline-flex" }}>
                            <h4 className="infoLabel">
                                Aguardando Pagamento: {" "}
                            </h4>
                            &nbsp;&nbsp;
                            <div className="lds-ellipsis" style={{ float: "none" }}>
                                <div></div>
                                <div></div>
                                <div></div>
                            </div>
                        </div>
                    </div>

                </Alert>

                <LoadingModal open={CaixaPostalStore.obs.loading} onClose={() => CaixaPostalStore.obs.loading = false} title={"Gerando QR Code"} />

                <Dialog
                    isOpen={this.obs.open_visualiza_mensagem}
                    onClose={(e) => this.obs.open_visualiza_mensagem = false}
                    title={"Mensagem"}
                    style={{ width: 600 }}
                >
                    <div className={Classes.DIALOG_BODY}>

                        <b>Assunto: {this.obs.mensagens[1]}</b>

                        <br />
                        <br />

                        <div style={{ maxHeight: 500, overflow: "auto", padding: "0px 10px 0px 0px" }}>
                            <div dangerouslySetInnerHTML={{ __html: this.obs.mensagens[0] }} />
                        </div>

                    </div>

                    <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                        <Button text="Fechar" intent="primary" onClick={() => this.obs.open_visualiza_mensagem = false} />
                    </div>

                </Dialog>

                <Dialog
                    isOpen={this.obs.open_visualiza_erro}
                    onClose={(e) => this.obs.open_visualiza_erro = false}
                    title={"Erros"}
                    style={{ width: 600 }}
                >
                    <div className={Classes.DIALOG_BODY}>
                        <p style={{ marginBottom: 25, marginTop: -25 }}>
                            Para o item listado abaixo, será necessário realizar novamente a solicitação.
                        </p>

                        <b>{this.obs.mensagens_erro[1]}</b>

                        <br />
                        <br />

                        {this.obs.mensagens_erro[0]}

                    </div>

                </Dialog>

            </>
        )
    }
}

